<div>
  <nav class="navbar-expand">
    <ul class="navbar-nav">
      <li class="nav-item" routerLinkActive="active" *ngFor="let item of navItems">
        <a class="nav-link" [routerLink]="item.route">{{item.name | translate}}</a>
      </li>
    </ul>
  </nav>
</div>